var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForyouInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6be8a;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "foryou-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recomendados"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.43 17.39 27.57 11.61 21.32 17.62 18.43 17.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 10 19.57 5.61 13.32 11.62 13 10"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.39,17.72h0l-1.37-1.18h-6.5l-.32-4.92-5.61-.28-.85-6.23L12.3,4.7h0L10.86,3.44l-5.5,8.39.45,13.31,15.24.11,6.5-7.39Zm-9.26-4.66.06,3.48H15.07Zm-.74-.35-3.1,3.53-.51-3.71Zm-10.58.37,4.75-7.54,1.69,11.88-6.46,6.2ZM19.57,24h-12L14,17.73h11.1L19.61,24Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForyouInactive);
export default __webpack_public_path__ + "static/media/foryou-inactive.c425aac8e6314cd03d4bc41f1382978c.svg";
export { ForwardRef as ReactComponent };